import React from 'react';

import { Button, Table } from 'antd';
import { useTranslation } from 'react-i18next';

import { defaultPaginationConfig } from 'segments/utils/constants/common';
import { shortName } from 'segments/utils/helpers/shortName';

import {
  convertGroupsToTable,
  GroupeInfo,
  useDeleteGroupeMutation,
  MinUsersTable
} from 'features/groups';

export interface TableData extends GroupeInfo {
  key: number;
}

type Props = {
  items: GroupeInfo[];
  itemsTotal?: number;
  isLoading?: boolean;
  currentPage?: number;
  defaultPageSize?: number;
  onPageChange?: (page: number, pageSize: number) => void;
  onCreateClick: () => void;
  onEditClick: (groupeId: number) => void;
};

export const GroupsTable = (props: Props) => {
  const {
    items,
    itemsTotal = 0,
    isLoading,
    currentPage = 1,
    defaultPageSize = 30,
    onPageChange,
    onEditClick,
    onCreateClick,
  } = props;

  const [deleteGroupe, { isLoading: isCoartDeleting }] = useDeleteGroupeMutation();
  const { t } = useTranslation(undefined, { keyPrefix: 'table' });
  return (
    <Table<TableData>
      size="small"
      dataSource={convertGroupsToTable(items)}
      loading={isLoading}
      scroll={{ x: 1200 }}
      expandable={{
        expandedRowRender: (record) => (<MinUsersTable items={record.users} isLoading={false} groupeId={record.id} />)
      }}
      pagination={{
        ...defaultPaginationConfig,
        defaultPageSize,
        current: currentPage,
        total: itemsTotal,
        onChange: onPageChange,
      }}
    >
      <Table.Column<TableData>
        title={t('id', 'ID')}
        dataIndex="id"
        width={30}
      />
      <Table.Column<TableData>
        title={t('name', 'Названия')}
        dataIndex="name"
        width={240}
      />
      <Table.Column<TableData>
        title={t('coachName')}
        dataIndex="coachName"
        width={140}
        render={(coachName: string) => shortName(coachName)}
      />
      <Table.Column<TableData>
        title={t('price')}
        dataIndex="price"
        width={100}
        render={(price: number) => `${price}₽`}
      />
      <Table.Column<TableData>
        title={t('priceIndividual')}
        dataIndex="priceIndividual"
        render={(priceIndividual: number) => `${priceIndividual}₽`}
      />
      <Table.Column<TableData>
        dataIndex="id"
        width={60}
        render={(id: number) => (
          <Button type="primary" onClick={() => onEditClick(id)}>
            {t('edit', 'Редактировать')}
          </Button>
        )}
      />
      <Table.Column<TableData>
        dataIndex="id"
        width={60}
        title={onCreateClick && <Button type="primary" onClick={onCreateClick}>{t('create')}</Button>}
        render={(id: number) => (
          <Button type="primary" danger disabled={isCoartDeleting} onClick={() => {
            deleteGroupe(id);
          }}
          >
            {t('delete', 'Удалить')}
          </Button>
        )}
      />
    </Table>
  );
};
